var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgServiceIntroduction4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 450,
    viewBox: "0 0 550 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.971 10.1732C228.971 6.6937 232.436 4.27807 235.701 5.48201L428.907 76.7352C430.872 77.4599 432.177 79.3322 432.177 81.4264V358.283C432.177 361.762 428.711 364.178 425.447 362.974L232.241 291.721C230.276 290.996 228.971 289.124 228.971 287.029V10.1732Z",
    fill: "url(#paint0_linear_977_1150)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.618 26.7474C188.618 23.2679 192.083 20.8523 195.348 22.0562L388.554 93.3095C390.518 94.0341 391.824 95.9064 391.824 98.0006V374.857C391.824 378.336 388.358 380.752 385.093 379.548L191.888 308.295C189.923 307.57 188.618 305.698 188.618 303.604V26.7474Z",
    fill: "url(#paint1_linear_977_1150)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.75 47.6439C154.75 44.1644 158.216 41.7488 161.48 42.9527L354.686 114.206C356.651 114.931 357.956 116.803 357.956 118.897V395.753C357.956 399.233 354.49 401.649 351.226 400.445L158.02 329.191C156.055 328.467 154.75 326.594 154.75 324.5V47.6439Z",
    fill: "url(#paint2_linear_977_1150)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 69.9818C118 66.5023 121.466 64.0867 124.73 65.2906L317.936 136.544C319.901 137.268 321.206 139.141 321.206 141.235V418.091C321.206 421.571 317.74 423.986 314.476 422.782L121.27 351.529C119.305 350.805 118 348.932 118 346.838V69.9818Z",
    fill: "url(#paint3_linear_977_1150)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.147 173.779L278.691 220.618",
    stroke: "#61B0F7",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.147 201.162L278.691 248",
    stroke: "#61B0F7",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.147 228.545L278.691 275.383",
    stroke: "#61B0F7",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.146 255.926L278.691 302.764",
    stroke: "#61B0F7",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M362 403C362 427.301 342.301 447 318 447C293.699 447 274 427.301 274 403C274 378.699 293.699 359 318 359C342.301 359 362 378.699 362 403Z",
    fill: "#3A7EFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M300 402.742L313.632 417L337 391",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_977_1150",
    x1: 330.574,
    y1: 3,
    x2: 330.574,
    y2: 365.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90C1F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_977_1150",
    x1: 290.221,
    y1: 19.5742,
    x2: 290.221,
    y2: 382.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74A9DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_977_1150",
    x1: 256.353,
    y1: 40.4707,
    x2: 256.353,
    y2: 402.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D9AD7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_977_1150",
    x1: 94.5809,
    y1: 170.537,
    x2: 412.721,
    y2: 369.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9E5FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgServiceIntroduction4);
export default __webpack_public_path__ + "static/media/ImgServiceIntroduction4.c69233f94d0ce3ebda8cf6b4f3a8cceb.svg";
export { ForwardRef as ReactComponent };